module.exports = __webpack_public_path__ + "img/america-6.4a49683d.png";